import React from 'react'
import { IcoMoon, ShieldCheckedIcon } from '@usap/uicomponents'
import { ConfirmationMessageContainer } from '../style/Confirmation.css'

const ConfirmationMessage = ({ item }) => {
  const { customerEmailAddress } = { ...item }

  return (
    <ConfirmationMessageContainer>
      <h1>
        <IcoMoon
          icon={ShieldCheckedIcon}
          width="34px"
          height="44px"
        />
        <span>You&apos;re almost done!</span>
      </h1>
      <p>
        A copy of your request has been emailed to
        &nbsp;
        <span>{customerEmailAddress}</span>
        . We&apos;ll inspect your parts upon receipt and issue a refund based
        on your original purchase cost.
      </p>
    </ConfirmationMessageContainer>
  )
}

export default ConfirmationMessage
